import '../assets/css/lateralMenu.css'
import { useState, useImperativeHandle, forwardRef } from 'react';
import { motion } from 'framer-motion';

export const LateralMenu = forwardRef(({ativaResp},ref)=>{

    const [showLateralMenu, setShowLateralMenu] = useState(false)

    useImperativeHandle(ref, (value) => ({
        // methods connected to `ref`
        showLateralMenu: (value) => { 
            setShowLateralMenu(value)
        }
        }))

    return <>
    
    <motion.div 
        initial={{ opacity: 0,
            width: 0,
            padding: 0,
            display: 'none' }}
        animate={ativaResp ? 
            showLateralMenu ? {width: '85%', opacity: 1, display: 'block'} : { opacity: 0, width: 0, padding: 0, display: 'none' } : 
            showLateralMenu ? {width: '30vw', opacity: 1, display: 'block'} : { opacity: 0, width: 0, padding: 0, display: 'none' }}
            transition={{
                width: { duration: 0.2 }, 
                opacity: { duration: 0.25 }, 
                display: { duration: showLateralMenu ? 0.1 : 0.5}
                }}
    className={`lateralMenu `}>
                <div className="lateralMenuCard">
                    <div className="closeMenuBtn">
                        <div className="insideMenuBtn" onClick={()=>setShowLateralMenu(false)}>Fechar</div>
                    </div>

                    <div className="titleLat">Comunidade São Pedro</div>
                    <div className="divisorLine"></div>

                    <div className="menulateral">
                        <div className="optionMenu" tipooption="home" onClick={()=>window.location.href = 'PaginaInicial'}>
                            <div className="imgOpt"></div> 
                            <div className="textOpt">Página Inicial</div></div>
                        <div className="optionMenu" tipooption="descobrir" onClick={()=>window.location.href = 'Sobre'}>
                            <div className="imgOpt"></div> 
                            <div className="textOpt">Sobre a comunidade</div></div>
                        <div className="optionMenu" tipooption="pastorais" onClick={()=>window.location.href = 'PastoraisEMovimentos'}>
                            <div className="imgOpt"></div> 
                            <div className="textOpt">Pastorais e Movimentos</div></div>
                        <div className="optionMenu" tipooption="programacao" onClick={()=>window.location.href = 'Programacao'}>
                            <div className="imgOpt"></div> 
                            <div className="textOpt">Programação</div></div>
                        <div className="optionMenu" tipooption="liturgia" onClick={()=>window.location.href = 'LiturgiaDiaria'}>
                            <div className="imgOpt"></div> 
                            <div className="textOpt">Liturgia Diária</div></div>
                        <div className="optionMenu" tipooption="biblia" onClick={()=>window.location.href = 'Biblia'}>
                            <div className="imgOpt"></div> 
                            <div className="textOpt">Bíblia</div></div>
                        {/* <div className="optionMenu" tipooption="onde">
                            <div className="imgOpt"></div> 
                            <div className="textOpt">Onde Encontrar</div></div> */}
                        <div className="social">
                            <a className="socialIcons" socialicon="facebook" href = "https://www.facebook.com/comunidadesaopedrobh/"></a>
                            <a className="socialIcons" socialicon="instagram" href = "https://www.instagram.com/comunidadesaopedrobh/"></a>
                            <a className="socialIcons" socialicon="whatsapp" href = "https://wa.me/5531995737237"></a>
                        </div>
                    </div>
                </div>
        </motion.div>

        </>
})

export default LateralMenu;